import { CurrencyPipe } from "@angular/common"
import { Component, Input } from "@angular/core"
import { isEmpty } from "lodash"

import { MerchantReferralCampaignPagesColors } from "../../shared/merchant-referral"

@Component({
  selector: "app-rewards-table",
  templateUrl: "./rewards-table.component.html",
  styleUrls: ["./rewards-table.component.scss"]
})
export class ReferralMagicRewardsTableComponent {
  @Input() rewards: any
  @Input() colors: MerchantReferralCampaignPagesColors

  constructor(private currencyPipe: CurrencyPipe) {}

  getRewardDisplayName(reward) {
    if (!reward) {
      return
    }

    if (!isEmpty(reward.name)) {
      return reward.name
    }

    const type = reward.type || reward.value_type

    switch (type) {
      case "amazon":
        return `${this.currencyPipe.transform(reward.value, "USD", true)} Amazon Gift Card`
      case "custom":
        return reward.text
      case "none":
        return "None"
      default:
        if (reward.value != null) {
          return `${this.currencyPipe.transform(reward.value, "USD", true)} Off Next Order`
        }
        if (reward.rate) {
          return `${reward.rate}% Off Next Order`
        }
        return
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/onelocal/onelocal/src/my-referral/src/app/referral-magic/rewards-table/rewards-table.component.ts